import { Button } from '@florencelabs/button';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppointment } from '@provider-directory/contexts/AppointmentContext';
import { useAnalytics } from '../analytics/analytics-provider';

export const SceneNavigation = ({
  onPrev,
  id,
}: {
  onPrev: () => void;
  id: string;
}): ReactElement => {
  const { t } = useTranslation();
  const analytics = useAnalytics();
  const { appointment } = useAppointment();

  return (
    <div
      className={
        'mt-6 flex w-full flex-row justify-center border-t border-gray-700/10 py-6'
      }
    >
      <div
        className={
          'flex w-full flex-row items-center justify-between desktop:max-w-[485px]'
        }
      >
        <Button
          testId={'go-back-btn'}
          size={'xsmall'}
          variant={'systemLink'}
          icon={'chevron_left'}
          iconPosition={'left'}
          onPress={() => {
            analytics.track('PRESSED_BACK_ON_DTREE', {
              questionId: id,
              specialtyBranch: appointment.specialtyBranch,
            });
            onPrev();
          }}
          className={
            'text-body-medium-semibold hover:cursor-pointer desktop:text-body-medium-semibold'
          }
        >
          {t('schedule.back')}
        </Button>
        <Button
          form={id}
          testId={'next-btn'}
          type={'submit'}
          variant={'clientMain'}
          size={'small'}
          className={
            'text-body-medium-semibold hover:cursor-pointer desktop:text-body-medium-semibold'
          }
        >
          {t('schedule.next')}
        </Button>
      </div>
    </div>
  );
};
